import { initializeApp } from "@firebase/app";
import React, { useEffect, useState } from "react";
import Loader from "../../generalComponents/Loader";
import {
	query,
	addDoc,
	onSnapshot,
	doc,
	updateDoc,
	collection,
	getFirestore,
} from "@firebase/firestore";
import { firebaseConfig, storage } from "../../../config/firebaseConfig";
import { getDownloadURL, ref, uploadBytesResumable } from "@firebase/storage";
import {
	askDataKeyValue,
	updateDocumentById,
} from "../../../utils/actions/firebase/firebaseActions";
import Message from "../../generalComponents/Message";
import ProgressBar from "../../generalComponents/ProgressBar";
import Select from "react-select";
import { formatMs } from "@material-ui/core";

export const NoveltiesForm = ({
	listEmployees,
	listNovelties,
	closeModal1,
	user,
	documentToEdit,
	setDocumentToEdit,
	company,
}) => {
	const initialForm = {
		id: null,
		employeeDocument: "",
		employeeName: "",
		noveltyName: "",
		dateCreation: "",
		dateInitial: "",
		dateFinal: "",
		userCreation: "",
		userUpdate: "",
		dateUpdate: "",
		userAuthorizer: "",
		comment: "",
		Doc_Novedad: "",
		name_Doc_Novedad: "",
		// Otro_doc_novedad: "",
		// name_Otro_doc_novedad: "",
		// reason: "",
		// commentBoss:"",
	};

	const app = initializeApp(firebaseConfig);
	const db = getFirestore(app);
	const [form, setForm] = useState(initialForm);
	const [loading, setLoading] = useState(false);
	const [error, setError] = useState(null);
	const [fileToRec, setFileToRec] = useState(null);
	const [storageRef, setStorageRef] = useState(null);
	const [progressLoad, setProgressLoad] = useState(-1);
	const [selectEmployees, setSelectEmployees] = useState(null);

	useEffect(() => {
		convertEmployees();
		if (documentToEdit) {
			setForm(documentToEdit);
		} else {
			setForm(initialForm);
		}
	}, [documentToEdit]);

	const convertEmployees = () => {
		let selectUser = [];
		listEmployees.map((item) => {
			if (item.status === "activo") {
				const lineList = {
					value: item.document,
					label: item.document + " - " + item.name,
					employe: item,
				};
				selectUser.push(lineList);
			}
		});
		setSelectEmployees(selectUser);
	};

	const handleChange = (e) => {
		setForm({
			...form,
			[e.target.name]: e.target.value,
		});
	};

	const handleSelectFile = (e) => {
		setLoading(true);
		const file = e.target.files[0];
		// console.log("tamaño del archivo: ", file.size);

		if (file.size > 20000000) {
			// console.log("excede el máximo permitido");
			setError("Tamaño de archivo supera 20 MB ");
			setLoading(false);
			return;
		} else {
			setFileToRec(file);
			setError(null);
		}

		if (form.employeeDocument) {
			const storageRef = ref(
				storage,
				"resource/" +
					company +
					"/employees/" +
					form.employeeDocument +
					"/novelties/" +
					e.target.name +
					"/" +
					file.name
			);
			setStorageRef(storageRef);
			form.name_Doc_Novedad = file.name;
		} else {
			alert("debe seleccionar primero un empleado...");
		}

		setLoading(false);
	};

	const loadFile = async () => {
		return new Promise((resolve, reject) => {
			const uploadTask = uploadBytesResumable(storageRef, fileToRec);

			uploadTask.on(
				"state_changed",
				(snapshot) => {
					const progress = Math.floor(
						(snapshot.bytesTransferred / snapshot.totalBytes) * 100
					);
					setProgressLoad(progress);

					switch (snapshot.state) {
						case "paused":
							console.log("Upload is paused");
							break;
						case "running":
							console.log("Upload is running");
							break;
					}
				},
				(error) => {
					console.log(error);
					reject(error);
				},
				async () => {
					try {
						const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
						console.log("Si entra a grabar doc_novedad", downloadURL);
						form.Doc_Novedad = downloadURL;
						resolve(downloadURL);
					} catch (error) {
						console.error("Error al obtener la URL de descarga", error);
						reject(error);
					} finally {
						// Puedes hacer cualquier limpieza aquí si es necesario
					}
				}
			);
		});
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		if (!form.employeeName) {
			alert("Debe sleccionar un empleado...");
			return;
		}
		if (!form.noveltyName) {
			alert("Debe seleccionar una novedad...");
			return;
		}
		if (!form.dateInitial) {
			alert("Debe seleccionar una fecha de inicio de la novedad...");
			return;
		}
		if (!form.dateFinal) {
			alert("debe seleccionar una fecha de finaliación de la novedad...");
			return;
		}
		if (form.dateInitial > form.dateFinal) {
			alert("La fecha final no puede ser antes de la inicial...");
			return;
		}
		if (
			form.noveltyName === "Permiso" ||
			form.noveltyName == "Licencia no remunerada"
		) {
			// console.log("Form en permiso:", form);
			if (!form.reason) {
				alert("Debe Colocar el motivo del permiso...");
				return;
			}
			if (!form.userAuthorizer) {
				alert("Debe seleccionar alguien que autorice el permiso...");
				return;
			}
		}

		if (form.noveltyName === "Retiro") {
			if (!form.dateOut) {
				alert("Debe Colocar la fecha de retiro...");
				return;
			}
			try {
				const nameCollection0 = "employees-" + company;
				const key = "document";
				const value = form.employeeDocument;
				const responseDataEmployee = await askDataKeyValue(
					nameCollection0,
					key,
					value
				);
				const dataEmployee = responseDataEmployee.data[0];
				dataEmployee.status = "retirado";
				dataEmployee.dateOut = form.dateOut;
				form.dateInitial = form.dateOut;
				form.dateFinal = form.dateOut;
				// console.log("datos del empleado: ", dataEmployee);
				await updateDocumentById(
					nameCollection0,
					dataEmployee.id,
					dataEmployee
				);
				setLoading(false);
			} catch (error) {
				setError(error);
				setLoading(false);
				return;
			}
		}
		setLoading(true);
		const fechita = new Date();
		// const actualDate = fechita.toLocaleDateString();
		const year = fechita.getFullYear();
		const month = fechita.getMonth() + 1; // Los meses son indexados desde 0, así que sumamos 1
		const day = fechita.getDate();
		const twoDigits = (number) => (number < 10 ? `0${number}` : number);
		const actualDate = `${year}-${twoDigits(month)}-${twoDigits(day)}`;
		const nameCollection = "noveltiesEmployees-" + company;

		if (form.id === null) {
			if (form.name_Doc_Novedad) {
				try {
					await loadFile();
				} catch (error) {
					setError("Error durante la carga del archivo", error);
				}
			}
			form.userCreation = user;
			form.dateCreation = actualDate;
			try {
				const res = await addDoc(collection(db, nameCollection), form);
				if (res.id) {
					const docRef = doc(db, nameCollection, res.id);
					await updateDoc(docRef, {
						id: res.id,
					});
				}
			} catch (error) {
				setError("Error al agregar el documento", error);
			}
		} else {
			if (storageRef) {
				try {
					await loadFile();
				} catch (error) {
					setError("Error durante la carga del archivo", error);
				}
			}
			form.userUpdate = user;
			form.dateUpdate = actualDate;
			// console.log(">> va a actualizar form: ", form);
			updateDocumentById(nameCollection, form.id, form);
			setDocumentToEdit(form);
		}
		setLoading(false);
		handleReset();
		closeModal1();
	};

	const handleReset = () => {
		setForm(initialForm);
		setStorageRef(null);
	};

	const closeForm = () => {
		if (form.id != null) {
			setDocumentToEdit(documentToEdit);
		}
		closeModal1();
	};

	const handleSelectList = async (selectedOption, { name }) => {
		const value = selectedOption.value;
		const employe = selectedOption.employe;
		// console.log("Employe: ", employe);
		// console.log("value:", value);
		setForm({
			...form,
			[name]: value,
		});
	};
	const handleSelectEmploye = async (selectedOption) => {
		const employe = selectedOption.employe;
		// console.log("Employe.name: ", employe.name);
		setForm({
			...form,
			employeeDocument: employe.document,
			employeeName: employe.name,
		});
	};
	const handleSelectAutorizerPermision = async (selectedOption) => {
		const employe = selectedOption.employe;
		// console.log("Employe: ", employe);
		setForm({
			...form,
			userAuthorizer: employe.email,
			aprovalStatus: "Pendiente",
			commentBoss: "",
		});
	};

	const obtenerFechaActual = () => {
		const fechaActual = new Date();
		const dia = fechaActual.getDate().toString().padStart(2, "0");
		const mes = (fechaActual.getMonth() + 1).toString().padStart(2, "0"); // Meses en JavaScript van de 0 a 11
		const anio = fechaActual.getFullYear();
		return `${anio}-${mes}-${dia}`;
	};

	return (
		<div className="conten0">
			<div className="conten1">
				<h3 className="titulo1">
					{documentToEdit ? "Editar Novedad" : "Agregar Novedad"}
				</h3>
				<form onSubmit={handleSubmit} className="formRH">
					{loading ? (
						<Loader />
					) : (
						<div>
							<div className="containerFormRH">
								<label className="humanLabel0">Empleado *</label>
								{form.id === null ? (
									<Select
										className="humanSelect0"
										options={selectEmployees}
										name="employeeDocument"
										defaultInputValue={
											documentToEdit ? documentToEdit.employeeDocument : ""
										}
										value={
											form.employeeDocument
												? {
														label:
															form.employeeDocument + "-" + form.employeeName,
														value: form.employeeDocument,
												  }
												: null
										}
										onChange={handleSelectEmploye}
										placeholder="Empleado ?"
									/>
								) : (
									<label className="humanInput0">{form.employeeName}</label>
								)}

								<label className="humanLabel0">Tipo de Novedad *</label>
								{form.id === null ? (
									<Select
										className="humanSelect0"
										options={listNovelties}
										name="noveltyName"
										defaultInputValue={
											documentToEdit ? documentToEdit.noveltyName : ""
										}
										value={
											form.noveltyName
												? { label: form.noveltyName, value: form.noveltyName }
												: null
										}
										onChange={handleSelectList}
										placeholder="Tipo de Novedad ?"
									/>
								) : (
									<label className="humanInput0">{form.noveltyName}</label>
								)}

								<label className="humanLabel0">Fecha Inicial</label>
								<input
									type="date"
									name="dateInitial"
									placeholder="Fecha Inicial"
									onChange={handleChange}
									value={form.dateInitial}
									className="humanInput0"
								/>
								<label className="humanLabel0">Fecha Final </label>
								<input
									type="date"
									name="dateFinal"
									placeholder="Fecha Final"
									onChange={handleChange}
									value={form.dateFinal}
									className="humanInput0"
								/>

								<label className="humanLabel0">Comentario</label>
								<textarea
									// type="text"
									name="comment"
									placeholder="Comentario"
									onChange={handleChange}
									value={form.comment}
									className="humanInput0"
								/>
								<br />
								{form.noveltyName === "Retiro" && (
									<div>
										<article className="titulo2">... RETIRO ...</article>
										<label className="humanLabel0">Fecha de Retiro</label>
										<input
											type="date"
											name="dateOut"
											placeholder="Fecha de Retiro"
											onChange={handleChange}
											value={form.dateOut}
											className="humanInput0"
										/>
									</div>
								)}
								{(form.noveltyName === "Permiso" ||
									form.noveltyName === "Licencia no remunerada") && (
									<div>
										{form.noveltyName === "Permiso" ? (
											<article className="titulo2">... PERMISO ...</article>
										) : (
											<article className="titulo2">
												... LICENCIA NO REMUNERADA ...
											</article>
										)}
										<label className="humanLabel0">Motivo *</label>
										{form.id === null ? (
											<input
												type="text"
												name="reason"
												placeholder="Motivo "
												onChange={handleChange}
												value={form.reason}
												className="humanInput0"
											/>
										) : (
											<label className="humanInput0">{form.reason}</label>
										)}

										<label className="humanLabel0">Jefe Autorizador</label>

										<Select
											className="humanSelect0"
											options={selectEmployees}
											name="userAuthorizer"
											defaultInputValue={
												documentToEdit ? documentToEdit.userAuthorizer : ""
											}
											value={
												form.userAuthorizer
													? {
															label: form.userAuthorizer,
															value: form.userAuthorizer,
													  }
													: null
											}
											onChange={handleSelectAutorizerPermision}
											placeholder="Quien Autoriza ?"
										/>
									</div>
								)}
								{form.name_Doc_Novedad ? (
									<label className="titulo8">
										Archivo a subir: {form.name_Doc_Novedad}
									</label>
								) : (
									<div className="input-container">
										<label htmlFor="fileInput">Seleccionar Archivo</label>
										<input
											type="file"
											accept=".pdf"
											name={doc}
											id="fileInput"
											onChange={handleSelectFile}
										/>
									</div>
								)}
							</div>

							{error && <Message mensaje={error} bgColor="#dc3545" />}
							<input
								type="submit"
								value="Enviar"
								className="btn-send-reg-asign"
							/>
							{!documentToEdit && (
								<input
									type="reset"
									value="Limpiar"
									onClick={handleReset}
									className="btn-clean-reg-asign"
								/>
							)}
							<input
								type="reset"
								value="Cerrar"
								onClick={closeForm}
								className="btn-close-reg-asign"
							/>
						</div>
					)}
				</form>
			</div>
		</div>
	);
};
